import React, { useState } from "react";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import "./JoinCodeModal.css";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function JoinCodeModal({ show, onHide, programCode }) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [showCode, setShowCode] = useState(false);

  const handleToggleCode = () => {
    setShowCode((prev) => !prev);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("invite_students")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <p className="text-center">{t("invite_students_description")}</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={6} className="text-center">
              <div className={`flip-card ${showCode ? "show-code" : ""}`}>
                <div className="flip-card-inner">
                  <div className="flip-card-front">
                    <Button
                      variant="secondary"
                      className="mt-3"
                      onClick={handleToggleCode}
                    >
                      {t("view_course_code")}
                    </Button>
                  </div>
                  <div className="flip-card-back">
                    <Button
                      variant="secondary"
                      className="mt-3"
                      onClick={handleToggleCode}
                    >
                      {programCode}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          {t("close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default JoinCodeModal;
